Serenity.EntityGrid.prototype['getButtons'] = (function (old) {
    return function () {

        var buttons = old.call(this) as Serenity.ToolButton[];

        var addButton = Q.tryFirst(buttons, x => x.cssClass === "add-button");
        if (addButton)
            addButton.icon = "mdi mdi-plus-circle-outline text-lime";

        var refreshButton = Q.tryFirst(buttons, x => x.cssClass === "refresh-button");
        if (refreshButton)
            refreshButton.icon = "fa-refresh text-lime";

        var pickerButton = Q.tryFirst(buttons, x => x.cssClass === "column-picker-button");
        if (pickerButton)
            pickerButton.icon = "mdi mdi-table-column-plus-after";

        var excelButton = Q.tryFirst(buttons, x => x.cssClass === "export-xlsx-button");
        if (excelButton)
            excelButton.icon = "fa-file-excel-o";

        return buttons;
    };
})(Serenity.EntityGrid.prototype['getButtons']);

Serenity.EntityDialog.prototype['getToolbarButtons'] = (function (old) {
    return function () {

        var buttons = old.call(this) as Serenity.ToolButton[];

        var saveButton = Q.tryFirst(buttons, x => x.cssClass === "save-and-close-button");
        if (saveButton)
            saveButton.icon = "mdi mdi-content-save-all text-lime";

        var applyButton = Q.tryFirst(buttons, x => x.cssClass === "apply-changes-button");
        if (applyButton)
            applyButton.icon = "fa fa-floppy-o text-lime";

        var deleteButton = Q.tryFirst(buttons, x => x.cssClass === "delete-button");
        if (deleteButton)
            deleteButton.icon = "fa-trash-o text-red";

        var cloneButton = Q.tryFirst(buttons, x => x.cssClass === "clone-button");
        if (cloneButton)
            cloneButton.icon = "mdi mdi-content-copy";

        var editButton = Q.tryFirst(buttons, x => x.cssClass === "edit-button");
        if (editButton)
            editButton.icon = "ni ni-edit text-lime";

        return buttons;
    };
})(Serenity.EntityDialog.prototype['getToolbarButtons']);

Serenity.EntityDialog.prototype['updateInterface'] = (function (old) {
    return function () {

        old.call(this);

        if (this.saveAndCloseButton) {
            this.saveAndCloseButton.find('.button-inner')
                .html("<i class='mdi mdi-content-save-all text-lime'></i> " +
                    Q.htmlEncode(Q.text((this.isNew() ? 'Controls.EntityDialog.SaveButton' :
                    'Controls.EntityDialog.UpdateButton'))));
        }
    };
})(Serenity.EntityDialog.prototype['updateInterface']);

function mergeGridTitle() {
    if (this.mergeTitle && !this.mergeTitle())
        return;

    if (this.titleDiv && this.toolbar && this.toolbar.element && this.toolbar.element.length && this.titleDiv.parent().is('.s-DataGrid'))
        this.titleDiv.prependTo(this.toolbar.element);
}

var orgSetTitle = Serenity.DataGrid.prototype["setTitle"];
Serenity.DataGrid.prototype["setTitle"] = function (value) {
    orgSetTitle.call(this, value);
    mergeGridTitle.call(this);
};

var orgCreateToolbarExtensions = Serenity.EntityGrid.prototype["createToolbarExtensions"];
Serenity.EntityGrid.prototype["createToolbarExtensions"] = function () {
    orgCreateToolbarExtensions.call(this);
    mergeGridTitle.call(this);
    if (this.toolbar && this.toolbar.element) {
        var toolButtonsDivs = this.toolbar.element.children('.tool-buttons');
        toolButtonsDivs.children().children().each(function (i, el) {
            $(el).insertBefore($(el).closest('.tool-buttons'));
        });
        toolButtonsDivs.remove();
    }
}

Serenity.FileUploadEditor.prototype["getToolButtons"] = (function (old) {
    return function () {
        var buttons = old.call(this) as Serenity.ToolButton[];

        var uploadButton = Q.tryFirst(buttons, x => x.cssClass === "add-file-button");
        if (uploadButton)
            uploadButton.icon = "ni ni-clip text-lime";

        var deleteButton = Q.tryFirst(buttons, x => x.cssClass === "delete-button");
        if (deleteButton)
            deleteButton.icon = "ni ni-trash text-red";

        return buttons;
    }
})(Serenity.FileUploadEditor.prototype["getToolButtons"]);


Serenity.FilterPanel.prototype['getTemplate'] = (function (old) {
    return function () {

       return "<div id='~_Rows' class='filter-lines'>" +
            "</div>" +
            "<div id='~_Buttons' class='buttons'>" +
            "<button id='~_AddButton' class='ui-button ui-corner-all ui-widget add'></button>" +
            "<button id='~_SearchButton' class='ui-button ui-corner-all ui-widget search'></button>" +
            "<button id='~_ResetButton' class='ui-button ui-corner-all ui-widget reset'></button>" +
            "</div>" +
            "<div style='clear: both'>" +
            "</div>";
    };
})(Serenity.FilterPanel.prototype['getTemplate']);

$.datepicker.setDefaults({
    buttonImage: null,
    buttonImageOnly: false,
    buttonText: '<i class="mdi mdi-calendar-blank-outline"></i>'
});

Serenity.Toolbar.prototype['createButton'] = (function (old) {
    return function (container, b) {
        if (b.separator)
            container = $('<div class="buttons-inner"></div>').appendTo(container.parent());
        else
            container = container.parent().children().last();

        old.call(this, container, b);

        if (b.title == null || b.title.length === 0) {
            container.children().last().addClass('no-text');
        }

        if (b.separator)
            container.children().first().remove();
    }
})(Serenity.Toolbar.prototype['createButton']);

Serenity.ColumnPickerDialog.prototype['createLI'] = (function (old) {
    return function (col) {
        var allowHide = this.allowHide(col);
        return $("\n<li data-key=\"" + col.id + "\" class=\"" + (allowHide ? "" : "cant-hide") + "\">\n  <span class=\"drag-handle\">\u2630</span>\n  " + Q.htmlEncode(this.getTitle(col)) + "\n  " + (allowHide ? "<i class=\"js-hide fa fa-times\" title=\"" + Q.text("Controls.ColumnPickerDialog.HideHint") + "\"></i>" : '') + "\n  <i class=\"js-show fa fa-eye\" title=\"" + Q.text("Controls.ColumnPickerDialog.ShowHint") + "\"></i>\n</li>");
    };
})(Serenity.ColumnPickerDialog.prototype['createLI']);

Serenity.ColumnPickerDialog.prototype['getTemplate'] = (function (old) {
    return function () {
        var template = old.call(this);
        return template.replace('fa-list', 'fa-times');
    };
})(Serenity.ColumnPickerDialog.prototype['getTemplate']);

toastr.options.positionClass = 'toast-bottom-right';
Q.defaultNotifyOptions.positionClass = 'toast-bottom-right'

class MyGridRowSelectionMixin extends Serenity.GridRowSelectionMixin {
    constructor(grid, options) {
        super(grid, options);

        grid.getGrid().onHeaderClick.subscribe(() => {
            setTimeout(this.updateSelectAll.bind(this), 0);
        });
    }
}

Serenity.GridRowSelectionMixin = MyGridRowSelectionMixin;
